import type { TFunction } from 'i18next';
import type { U3141ChildLotChain, U3141LotDetailOperationTypeFromInitLU } from '../U3141Service';
import { NS } from '../U3141';
import { getOperationTypeLabel } from '../components/common/U3141LotOperationType';
import { u3141FormatLotGraphLabel } from './u3141FormatLotGraphLabel';
import { u3141LotHasAnnotatedLotChainDocument } from './u3141LotHasAnnotatedLotChainDocument';

/** Champs `data` d’un nœud lot sur le graphe React Flow (hors position / id). */
export function u3141BuildGraphNodeDisplayData(
  row: U3141ChildLotChain,
  t: TFunction,
  language: string,
  lotDetailOperationTypes?: U3141LotDetailOperationTypeFromInitLU[],
) {
  const lotLabel = u3141FormatLotGraphLabel(row.lotDetail?.lot, row.lotDetail?.partieDeLot);
  const indexAnnoter = row.lotDetail?.indexAnnoter === true;
  const hasAnnotatedLotChain = u3141LotHasAnnotatedLotChainDocument(row.lotDetail?.documentTypes);
  const annotatedChainOutdated =
    row.lotDetail?.documentTypes?.some(
      (d) => d.documentType === 'rfLotDetailAnnotatedLotChain' && d.indexMostRecent === true,
    ) ?? false;

  return {
    lot: lotLabel,
    cadastre: row.lotDetail?.cadastre?.cadastre ?? '',
    rank: row.lotDetail?.cadastre?.rankLabel ?? row.lotDetail?.cadastre?.rank ?? '',
    dateEstablishment: row.lotDetail?.dateEstablishment ?? '',
    operationType: getOperationTypeLabel(row.lotDetail?.operationType ?? '', language, lotDetailOperationTypes),
    dateCorrection:
      Array.isArray(row.lotDetail?.corrections) && row.lotDetail!.corrections!.length > 0
        ? row.lotDetail!.corrections![0]
        : null,
    nodePayload: row as unknown,
    visible: row.visible ?? false,
    indexAnnoter,
    indexAnnotatedLabel: indexAnnoter ? t('lblLotGraphIndexAnnotated', { ns: NS }) : undefined,
    hasAnnotatedLotChain,
    hasAnnotatedLotChainLabel: hasAnnotatedLotChain
      ? t('lblLotGraphHasAnnotatedLotChain', { ns: NS })
      : undefined,
    annotatedChainOutdated,
    annotatedChainOutdatedLabel: annotatedChainOutdated ? t('lblAnnotatedChainOutdatedTooltip', { ns: NS }) : undefined,
  };
}
